var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5",attrs:{"id":"containerInstallAsPwa"}},[_c('a',{class:this.class,attrs:{"target":"_blank","id":"btnInstallPwa"},on:{"click":_vm.clickLink}},[_vm._v(" "+_vm._s(_vm.$t("installApp"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }